// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"custom-contextmenu_contextMenu_1EuFN","link":"custom-contextmenu_link_y5C0-"};